import { COOKIES_TOKEN_SHARE_CONFIG } from '@shared/constants';

export const COOKIE_KEYS = {
  USER_ROLE: 'user_role',
  TOKEN: 'user_token',
  LOGOUT_CONTROL: 'logout_control',
  TOKEN_SHARED: process.env.NEXT_PUBLIC_TOKEN_SHARED_KEY || '',
  INTENDED_URL: 'intended_url',
} as const;

export const COOKIE_CONFIG = {
  DEFAULT_EXPIRES: 7, // 7 days
  DEFAULT_PATH: '/',
  SAME_SITE: 'strict',
  SECURE: process.env.NODE_ENV === 'production',
} as const;

export const AUTH_COOKIE_CONFIG = {
  ...COOKIES_TOKEN_SHARE_CONFIG,
  domain: process.env.NEXT_PUBLIC_AUTH_COOKIE_DOMAIN || '',
  expires: COOKIE_CONFIG.DEFAULT_EXPIRES,
};

export const AUTH_ERROR_MESSAGES = {
  ROLE_MISMATCH:
    'Your session role does not match your current account role. Please log in again.',
  ACCOUNT_DEACTIVATED: `Your account has been deactivated. \nPlease contact support if you believe this is an error.`,
} as const;

export const AUTH_ERROR_CODES = {
  ROLE_MISMATCH: 'ROLE_MISMATCH',
} as const;

export const FIREBASE_ERROR_CODES = {
  USER_DISABLED: 'Firebase: Error (auth/user-disabled).',
  POPUP_CLOSED: 'Firebase: Error (auth/popup-closed-by-user).',
} as const;

export const REFRESH_INTERVAL = 1000 * 60 * 30; // 30 minutes
